import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

export function Header(props) {
  const className = `${style.header} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

Header.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * child components to render on Header
   */
  children: PropTypes.arrayOf(PropTypes.element),
};

Header.defaultProps = {
  className: "",
};
